import { parse as parseContentDisposition } from 'content-disposition';

export const saveFile = (buffer: ArrayBuffer, headers: Headers) => {
  const objectUrl = URL.createObjectURL(new Blob([buffer]));
  const anchorElement = document.createElement('a');
  anchorElement.href = objectUrl;
  anchorElement.download = getFileNameFromHeaders(headers);
  document.body.appendChild(anchorElement);
  anchorElement.click();
  anchorElement.remove();
};

const getFileNameFromHeaders = (headers: Headers): string => {
  const contentDispositionHeader = headers.get('Content-Disposition');
  if (!contentDispositionHeader) {
    return '';
  }
  const parsedContentDisposition = parseContentDisposition(contentDispositionHeader);
  return parsedContentDisposition.parameters.filename || '';
};
